import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.div`
  display: flex;
  width: '100%';
  gap: 1rem;
`
export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;

  p {
    font-size: 16px;
  }
`

export const ContainerItems = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: .6rem;
  gap: .8rem;
`

export const CustomButton = styled(ButtonMui)`
  align-self: flex-end;
  width: 12rem;    
  height: 2.5rem !important;
  margin: 1.4rem .4rem .4rem 0 !important;
`

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .2rem;
`

export const ContainerCheckboxesOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: .8rem;
  margin: 1rem 0 3.2rem 0;
`
